import $ from 'jquery';
import AjaxForm from './ajax-form';
import { toggleButtonLoader } from '../utils/button-loader';
import AjaxLoadCustomerMenus from './ajax-load-customer-menus';
import CustomerSegment from './customer-segment';
import { DisableOnTargetValue } from '../components/disable-on-target-value';
import { SetInputValueOnTargetValue } from '../components/set-input-value-on-target-value';
import { AddTextToField } from '../components/add-text-to-field';
import { EmailTemplates } from '../components/email-templates';
import { CodeMirrorEditor } from '../components/code-mirror-editor';
import CopyInputValue from '../components/copy-value';
import { Accordion } from '../components/accordion';
import { AjaxPagination } from '../components/ajax-pagination';
import { SetValueOnClick } from '../components/set-value-on-click';
import SearchWidget from './search-widget';

export default class AjaxModal {
  static init() {
    this.xhrRequest = null;

    $(document).on('click', '.js__ajax-modal-btn', e => {
      e.preventDefault();
      const $button = $(e.currentTarget);
      const modalUrl = $button.data('conditional-url-value') ? $button.data('conditional-url') : $button.data('url');
      const successUrl = $button.data('success-url');
      const successReloadElementSelector = $button.data('success-reload-element');
      const successReloadElementTabSelector = $button.data('success-reload-tab');

      AjaxModal.show($button, modalUrl, successUrl, $newModal => {
        const successTemplate = $newModal.find('form').data('success-template');
        new AjaxForm(
          $newModal.find('.js__ajax-form'),
          successUrl,
          AjaxModal.formSubmitSuccessHandler(
            $newModal,
            successUrl,
            successTemplate,
            successReloadElementSelector,
            successReloadElementTabSelector,
          ),
        );
      });
    });
  }

  static show($button, modalUrl, successUrl, callback) {
    toggleButtonLoader($button, true);
    let $modal;

    if (AjaxModal.xhrRequest) {
      AjaxModal.xhrRequest.abort();
      AjaxModal.xhrRequest = null;
    }

    AjaxModal.xhrRequest = $.ajax({
      url: modalUrl,
      method: 'GET',
      cache: false,
    })
      .done(data => {
        const $body = $('body');
        $modal = $(data.replaceAll('%buttonValue%', $button.data('value-to-replace-in-modal')));
        if ($modal.length > 1) {
          window.location.replace(successUrl || modalUrl);
        } else {
          $body.append($modal);
          $modal
            .modal({
              onHidden: () => {
                $modal.next('.grecaptcha-badge').remove();
                $modal.remove();
              },
            })
            .modal('show');

          if ($button.data('modal-not-closable')) {
            $modal.modal('setting', 'closable', false);
          }

          callback($modal);
          this.initScriptsOnNewModal($modal);
          $modal.find('.js__ajax-modal-btn').on('click', () => {
            $modal.modal('hide');
          });

          const $modalBackdrop = $('.modal-backdrop');
          if ($modalBackdrop.length > 1) {
            $modalBackdrop.first().remove();
          }

          CustomerSegment.searchSegmentsInit();
        }
      })
      .always(() => {
        toggleButtonLoader($button, false);
      });
  }

  static formSubmitSuccessHandler(
    $modal,
    successUrl,
    successTemplate,
    successReloadElementSelector,
    successReloadElementTabSelector,
  ) {
    return data => {
      if (successReloadElementSelector) {
        $modal.modal('hide');
        AjaxLoadCustomerMenus.addDomElements(successReloadElementSelector, $(successReloadElementTabSelector));
      } else if (successUrl) {
        $modal.modal('hide');
      } else if (successTemplate) {
        $modal.find('.modal-body').html(data);
        $modal.modal('handleUpdate');
      }
    };
  }

  static initScriptsOnNewModal($modal) {
    DisableOnTargetValue.init($modal);
    SetInputValueOnTargetValue.init($modal);
    AddTextToField.init($modal);
    CopyInputValue.init();
    EmailTemplates.init();
    Accordion.init($modal);
    AjaxPagination.init($modal);
    SetValueOnClick.init($modal);
    CodeMirrorEditor.init($modal);
    SearchWidget.init(true);
    $modal.find('.ui.tabular.menu .item, .sylius-tabular-form .menu .item').tab();

    $('body').on('click', '.js__close-btn', e => {
      const $modal = $(e.currentTarget).closest('.modal');
      $modal.modal('hide');
    });
  }
}
